import { useState } from "react";
import { Box, Grid, Paper, Chip, Tabs, Tab } from "@mui/material";
import Header from "../../../components/Header";
import Scans from "./highligths-components/Scans";
import RarestLogsUnified from "./highligths-components/RarestLogsUnified";
import TiresiaAnomalies from "./highligths-components/TiresiaAnomalies";
import ExplainPanel from "./highligths-components/ExplainPanel";
import SummaryCards from "./highligths-components/SummaryCards";
import IntelligenceTab from "./highligths-components/IntelligenceTab";
import { useHighlightsData } from "./highligths-components/useHighlightsData";
import TableMatches from "./highligths-components/TableMatches";
import NetworkAnomaly from "./highligths-components/NetworkAnomaly";
import DataGridWrapper from "./highligths-components/IntExtTable";

const HIGHLIGHTS_PAPER_HEIGHT = 320;

const Highlights = () => {
  const [showExplain, setShowExplain] = useState(true);

  const {
    products = { lecs: true, agent: false },
    checkStart,
    eventsLoading,
    cardsSummaryLoading,
    cardsSummary,
    mapCountryData,
    externalIps,
    dnsCountData,
    dnsCountLoading,
    anomaliesTop,
    anomaliesRare,
    tiresiaLogs,
    tiresiaLogsLoading,
    activeSection,
    setActiveSection,
    severitySummary,
    sampleCriticalOrHighDetails,
    internalPriority,
    externalPriority,
    topInt,
    topExt,
    topAnomaliesBehaviors,
    topAnomaliesLogsRarest,
    fmtPriorityList,
    countByType
  } = useHighlightsData();

  return (
    <Box m="20px">
      {/* Header row */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Header
          title="Highlights"
          subtitle=""
          desc="Security overview of the most relevant events in the selected time window."
        />
        <Chip
          label={showExplain ? "Hide explain" : "Explain"}
          size="small"
          color="default"
          variant="outlined"
          onClick={() => setShowExplain((v) => !v)}
          sx={{ borderColor: "#459095", color: "#eaeaea", fontSize: 12 }}
        />
      </Box>

      {showExplain && (
        <ExplainPanel
          loading={eventsLoading || !checkStart}
          products={products}
          countByType={countByType}
          cardsSummary={cardsSummary}
          severitySummary={severitySummary}
          internalPriority={internalPriority}
          externalPriority={externalPriority}
          topInt={topInt}
          topExt={topExt}
          sampleCriticalOrHighDetails={sampleCriticalOrHighDetails}
          fmtPriorityList={fmtPriorityList}
          countTypesSystem={countByType}
        />
      )}

      {/* Tab bar */}
      <Paper sx={{ mt: 1, borderRadius: "15px", backgroundColor: "#1e1e1e" }} elevation={2}>
        <Tabs
          value={activeSection}
          onChange={(_, v) => setActiveSection(v)}
          textColor="inherit"
          indicatorColor="primary"
          sx={{
            minHeight: 40,
            "& .MuiTab-root": { textTransform: "uppercase", letterSpacing: 1, fontWeight: 600, fontSize: 12 },
            "& .Mui-selected": { color: "#459095" },
            "& .MuiTabs-indicator": { backgroundColor: "#459095" },
          }}
        >
          <Tab label="Security" />
          <Tab label="Intelligence" />
        </Tabs>
      </Paper>

      {/* Tab content */}
      <Grid container spacing={2} sx={{ backgroundColor: "#000", mt: 2, borderRadius: 2 }}>

        {/* ── Intelligence tab ── */}
        {activeSection === 1 && (
          <Grid size={12}>
            <IntelligenceTab
              mapCountryData={mapCountryData}
              externalIps={externalIps}
              dnsCountData={dnsCountData}
              dnsCountLoading={dnsCountLoading}
              products={products}
            />
          </Grid>
        )}

        {/* ── Security tab ── */}
        {activeSection === 0 && (
          <Grid size={12}>
            <Grid container spacing={2}>

              <Grid size={12}>
                <SummaryCards
                  products={products}
                  cardsSummary={cardsSummary}
                  severitySummary={severitySummary}
                  loading={cardsSummaryLoading || eventsLoading}
                />
              </Grid>

              {/* Riga 1: Scans | Conditional */}
              <Grid size={{ xs: 12, md: 6 }}>
                <Paper
                  sx={{ backgroundColor: "#1e1e1e", borderRadius: "15px", height: HIGHLIGHTS_PAPER_HEIGHT, overflow: "hidden", flexShrink: 0 }}
                  elevation={3}
                >
                  <Scans height={290} products={products} />
                </Paper>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                {products.lecs && products.agent ?
                  <Paper sx={{ backgroundColor: "#1e1e1e", borderRadius: "15px", height: HIGHLIGHTS_PAPER_HEIGHT, overflow: "hidden", flexShrink: 0 }}>
                    <TableMatches />
                  </Paper>
                  : products.lecs && !products.agent ?
                    <TiresiaAnomalies
                      topAnomaliesBehaviors={topAnomaliesBehaviors}
                      topAnomaliesLogsRarest={topAnomaliesLogsRarest}
                      tiresiaLogs={tiresiaLogs}
                      tiresiaLogsLoading={tiresiaLogsLoading}
                      height={HIGHLIGHTS_PAPER_HEIGHT}
                    />
                    : !products.lecs && products.agent ?
                      <NetworkAnomaly height={HIGHLIGHTS_PAPER_HEIGHT} />
                      : null}
              </Grid>

              {products.lecs &&
                <Grid size={6}>
                  <RarestLogsUnified anomaliesTop={anomaliesTop} anomaliesRare={anomaliesRare} fillHeight />
                </Grid>
              }


              <Grid size={6}>
                <DataGridWrapper />
              </Grid>
            </Grid>
          </Grid>
        )}

      </Grid>
    </Box>
  );
};

export default Highlights;